import {defineComponent} from 'vue';
import {NotifyBizRecordDO} from "@/declares/entity/payCenter/NotifyBizRecordDO";
import moment from 'moment';
import {notifyTypeOptions} from "@/declares/options/payCenter/notifyTypeOptions";
import {notifyBizStatusOptions} from "@/declares/options/payCenter/notifyBizStatusOptions";


class PayRecordNotifyRecordsProps {
  records: NotifyBizRecordDO[] = []
}

function PayRecordNotifyRecords(_props: any) {
  const props = _props as PayRecordNotifyRecordsProps;

  return () => <div class="pay-record-notify-records">
    <el-table size="mini" data={props.records} border>
      <el-table-column label="回调编号" prop="notifyNo" width="240px" align="center"/>
      <el-table-column label="回调时间" width="140px" align="center" v-slots={{
        default: (scope: { row: NotifyBizRecordDO }) => moment(scope.row.gmtNotify).format('YYYY-MM-DD HH:mm:ss')
      }}/>
      <el-table-column label="回调类型" prop="type" width="80px" align="center" v-slots={{
        default: (scope: { row: NotifyBizRecordDO }) =>
          (notifyTypeOptions.find(opt => opt.value === scope.row.type) || {}).label
      }}/>
      <el-table-column label="状态" align="center" width="100px" v-slots={{
        default: (scope: { row: NotifyBizRecordDO }) =>
          (notifyBizStatusOptions.find(opt => opt.value === scope.row.status) || {}).label
      }}/>
      <el-table-column label="异常" prop="error" align="center" width="200px"/>
    </el-table>
  </div>
}


export default defineComponent({
  props: {
    records: {type: Array, required: true}
  },
  setup: PayRecordNotifyRecords
});
